<template>
  <div>
    <div class="banner">
      <div class="banner-box" >
        <div class="title-box">
          <h2>{{$t('Personal.Updated_password.Change_password')}}</h2>
        </div>
      </div>
    </div>
    <div class="container my-3 layout">
      <div class="row align-self-center" v-if="authorized">
        <div class="col-12 p-3">
          <!-- <p>親愛的 {{user.enterprise_name}} {{user.name}}學員您好：</p>
          <p>請確認以下資料:</p>
          <br> -->
          <p>{{$t('Personal.Updated_password.Name')}}：<span class="bold">{{userInfo.name}}</span></p>
          <p> {{$t('Personal.Updated_password.Email')}}：<span class="bold">{{userInfo.email}} </span>({{$t('Personal.Updated_password.Change_account_remind')}})</p>
        </div>
        <div class="col-12">
          <form class="p-3" style="background-color:#FFF3E3;">
            <div class="form-group" v-if="showCurrentPassword">
              <label class="bold">{{$t('Personal.Updated_password.Current_password')}}</label>
              <div class="input-group">
                <input v-model="oldPassword"  :placeholder="($t('Personal.Updated_password.Current_password_remind'))" :type="passwordFieldType" class="form-control">
                <div class="input-group-append">
                  <span class="input-group-text pointer" @click="switchVisibility">
                    <img v-if="passwordFieldType === 'password'" src="../assets/image/icon&btn/icon_other/eye_off.png" style="width: 20px; cursor: pointer;">
                    <img v-else src="../assets/image/icon&btn/icon_other/eye_on.png" style="width: 20px; cursor: pointer;">
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="bold">{{$t('Personal.Updated_password.New_password')}}</label>
              <div class="input-group">
                <input v-model="newPassword" :placeholder="($t('Personal.Updated_password.New_password_remind'))" :type="passwordFieldType" class="form-control">
                <div class="input-group-append">
                  <span class="input-group-text pointer" @click="switchVisibility">
                    <img v-if="passwordFieldType === 'password'" src="../assets/image/icon&btn/icon_other/eye_off.png" style="width: 20px; cursor: pointer;">
                    <img v-else src="../assets/image/icon&btn/icon_other/eye_on.png" style="width: 20px; cursor: pointer;">
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="bold">{{$t('Personal.Updated_password.Confirm_password')}}</label>
              <div class="input-group">
                <input v-model="confirmPassword" :type="passwordFieldType" :placeholder="($t('Personal.Updated_password.Reenter_password_remind'))" class="form-control">
                <div class="input-group-append">
                  <span class="input-group-text pointer" @click="switchVisibility">
                    <img v-if="passwordFieldType === 'password'" src="../assets/image/icon&btn/icon_other/eye_off.png" style="width: 20px; cursor: pointer;">
                    <img v-else src="../assets/image/icon&btn/icon_other/eye_on.png" style="width: 20px; cursor: pointer;">
                  </span>
                </div>
              </div>
            </div>
          </form>
          <button type="submit" :disabled="!confirm" @click="updatedPassword" class="btn btn-primary">{{$t('Personal.Updated_password.Save')}}</button>
        </div>
      </div>
      <div class="row align-self-center" v-else>
        <div class="col-12 p-3">
        </div>
        <div class="col-12">
          <form class="p-3" style="background-color:#FFF3E3;">
            <div class="form-group">
              <label class="bold"> {{$t('Personal.Updated_password.Email_remind')}}</label>
              <div class="input-group">
                <input v-model="email"  :placeholder="($t('Personal.Updated_password.Email_remind'))" :type="passwordFieldType" class="form-control">
                <div class="input-group-append">
                  <span class="input-group-text pointer" @click="switchVisibility">
                    <img v-if="passwordFieldType === 'password'" src="../assets/image/icon&btn/icon_other/eye_off.png" style="width: 20px; cursor: pointer;">
                    <img v-else src="../assets/image/icon&btn/icon_other/eye_on.png" style="width: 20px; cursor: pointer;">
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="bold">{{$t('Personal.Updated_password.New_password')}}</label>
              <div class="input-group">
                <input v-model="newPassword" :placeholder="($t('Personal.Updated_password.New_password_remind'))" :type="passwordFieldType" class="form-control">
                <div class="input-group-append">
                  <span class="input-group-text pointer" @click="switchVisibility">
                    <img v-if="passwordFieldType === 'password'" src="../assets/image/icon&btn/icon_other/eye_off.png" style="width: 20px; cursor: pointer;">
                    <img v-else src="../assets/image/icon&btn/icon_other/eye_on.png" style="width: 20px; cursor: pointer;">
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="bold">{{$t('Personal.Updated_password.Confirm_password')}}</label>
              <div class="input-group">
                <input v-model="confirmPassword" :type="passwordFieldType" :placeholder="($t('Personal.Updated_password.Reenter_password_remind'))" class="form-control">
                <div class="input-group-append">
                  <span class="input-group-text pointer" @click="switchVisibility">
                    <img v-if="passwordFieldType === 'password'" src="../assets/image/icon&btn/icon_other/eye_off.png" style="width: 20px; cursor: pointer;">
                    <img v-else src="../assets/image/icon&btn/icon_other/eye_on.png" style="width: 20px; cursor: pointer;">
                  </span>
                </div>
              </div>
            </div>
          </form>
          <button type="submit" :disabled="!confirm" @click="resetPassword" class="btn btn-primary">{{$t('Personal.Updated_password.Save')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import api from '../store/api'
import { mapGetters } from 'vuex'

export default {
  name: 'Updated-Password',
  data () {
    return {
      email: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      confirm: false,
      passwordFieldType: 'password'
    }
  },
  watch: {
  },
  mounted () {
    this.scrollTop()
  },
  computed : {
    ...mapGetters([
      'authorized',
      'userInfo'
    ]),
    token () {
      return this.$route.query.token
    },
    showCurrentPassword () {
      return this.authorized
    }
  },
  watch: {
    confirmPassword (val) {
      if (val === this.newPassword && val !== '') {
        this.confirm = true
      } else {
        this.confirm = false
      }
    },
    newPassword (val) {
      if (val === this.confirmPassword && val !== '') {
        this.confirm = true
      } else {
        this.confirm = false
      }
    }
  },
  methods: {
    goPage (el) {
      this.$router.push({ name: el })
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    },
    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    async updatedPassword () {
      const self = this
      try {
        await api.post(`update_password`, {
          old_password: this.oldPassword,
          new_password: this.newPassword
        })
        this.$swal({
          title: '儲存成功',
          text: '下次登入請使用新密碼',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: '確定'
        }).then(function (isConfirm) {
        if (isConfirm.value === true) {
          self.$router.back()
        }})
      } catch (error) {
        console.error(error)
        // if (error.response && error.response.status === 422) {
        //   this.$swal({
        //     title: '連結失效，請至忘記密碼重新發送通知信',
        //     icon: 'info',
        //     showCancelButton: false,
        //     confirmButtonText: '確定'
        //   })
        // }
      }
    },
    async resetPassword () {
      const self = this
      try {
        await api.post(`password/reset`, {
          token: this.token,
          email: this.email,
          password: this.newPassword,
          password_confirmation: this.confirmPassword
        })
        this.$swal({
          title: '儲存成功',
          text: '下次登入請使用新密碼',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: '確定'
        }).then(function (isConfirm) {
        if (isConfirm.value === true) {
          self.$router.push({ name: 'Login' })
        }})
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .container {
    text-align: left;
  }
  .layout {
    overflow: hidden;
    min-height: 40vh;
  }
  .title-box {
    h2,h4 {
      font-weight: bolder;
      // color: #fff;
    }
    p {
      width: 80%;
      margin: auto;
      // color: #fff;
    }
  }
  .remind {
    color: red;
  }
  .banner {
    height: 250px;
    background-image: url('../assets/image/pic/banner_bg_welcome_top.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
    .banner-box {
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: auto;
    }
  }
  .clause {
    padding: 50px 0;
    .clause-box {
      h6{
        font-weight: bolder;
      }
    }
    .clause-box>ul {
      list-style-type: cjk-ideographic;
      li {
        margin: 20px 0;
      }
    }
    .red {
      color: red;
    }
  }
  .bold {
    font-weight: bolder;
  }
</style>
